module.exports = __webpack_public_path__ + "static/media/no-image-found.15ffdca4.png";